import React from 'react';
import { ISolicitationEntry } from '../../../../../contentful/types/ISolicitationEntry';
import { H4 } from '../../../../../ui';
import { IAsset } from '../../../../../contentful';
import { QuickLink } from '../../../../../components/common/quick-links/QuickLink';

interface ISolicitationDocuments {
	solicitation: ISolicitationEntry;
}

export default function SolicitationDocuments({
	solicitation,
}: ISolicitationDocuments) {
	const { bidDocuments, addendum, attachments, signInSheet, supportDocuments } =
		solicitation.fields;

	const renderLinks = (links: IAsset[]) =>
		links.map((link) => (
			<QuickLink key={link.id} type="asset" url={link.fields.file.url}>
				{link.fields.title}
			</QuickLink>
		));

	return (
		<div>
			{bidDocuments && (
				<>
					<H4 styling="h6">Bid Documents</H4>
					{renderLinks(bidDocuments)}
				</>
			)}

			{addendum && (
				<>
					<H4 styling="h6">Addendum</H4>
					{renderLinks(addendum)}
				</>
			)}

			{attachments && (
				<>
					<H4 styling="h6">Attachments</H4>
					{renderLinks(attachments)}
				</>
			)}

			{signInSheet && (
				<>
					<H4 styling="h6">Sign In Sheet</H4>
					{renderLinks(signInSheet)}
				</>
			)}

			{supportDocuments && (
				<>
					<H4 styling="h6">Support Documents</H4>
					{renderLinks(supportDocuments)}
				</>
			)}
		</div>
	);
}
